import './index.css'
import r2wc from '@r2wc/react-to-web-component'
import '@ungap/custom-elements'

import App from './App'
import { AutoSize } from './components/autosize/autosize'

const WebChat = r2wc(App, {
  props: {
    id: 'string',
    notificationsound: 'boolean',
  },
})

const script = document.querySelector('script[src*="init.js"]')
if (script) {
  const clientId = script.getAttribute('data-client-id')
  if (clientId) {
    const chatElement = document.createElement('truelark-chat')
    chatElement.id = clientId
    document.body.appendChild(chatElement)
  }
}

customElements.define('truelark-chat', WebChat)
customElements.define('auto-size', AutoSize, { extends: 'textarea' })
